module.exports = __webpack_public_path__ + "static/media/holiday.af345c2b.jpg";